import React from 'react'
import './index.scss'
import PaginationComponent from '@Components/Tables/Pagination'
import ResultsPerPage from '@Components/Tables/ResultsPerPage'
import { PaginationBody, PaginationInfo } from '@Entities/pagination'
import { Maybe } from '@Types'

interface PaginationAndLimitProps {
    count?: number
    limit?: number
    paginationInfo: Maybe<PaginationInfo>
    onPageChange(pagination: PaginationBody): void
    onLimitChange?: (newLimit: number) => void
}

const PaginationAndLimit = (props: PaginationAndLimitProps) => {
    const { count = 0, limit = 10, paginationInfo, onLimitChange, onPageChange } = props
    const showPagination = count > limit
    return (
        <div data-testid="pagination-controls">
            <section className="pagination-controls">
                <div className="pagination-controls-left">
                    {showPagination && (
                        <PaginationComponent limit={limit} paginationPages={paginationInfo} onChange={onPageChange} />
                    )}
                </div>
                <div className="pagination-controls-right">
                    {onLimitChange && (
                        <ResultsPerPage limit={limit} buttonValues={[10, 25, 50, 100]} onChange={onLimitChange} />
                    )}
                </div>
            </section>
        </div>
    )
}

export default PaginationAndLimit
